import { TokenProvider } from '~/hooks/auth/useMsalTokenProvider';
import { BackendClient } from './backend-client';
import { APIType } from './types';

export class RegistrationClient extends BackendClient {
    constructor(
        baseURL: string,
        tokenProvider: TokenProvider,
        sessionID: string
    ) {
        super(baseURL, tokenProvider, sessionID, APIType.REGISTRATION);
    }
}
